import axios from "axios";

export const instance = axios.create({
  baseURL: "https://walker0.pioneers-solutions.info/",
  headers: {
    "content-type": "application/json",
  },
});
export const baseUrl = "https://walker0.pioneers-solutions.info/images";
